import { Routes } from '@angular/router';
import { ProductDetailComponent } from './pages/product-detail/product-detail.component';
import { CategoriesPage } from './pages/categories/categories.page';
import { RouterUtil } from '@us/web/shared/utils';

export const routes: Routes = [
    { path: '', component: CategoriesPage },
    {
        path: `:${RouterUtil.Cog.ProductId}`,
        component: ProductDetailComponent
    }
];
